import { Link } from 'react-router-dom'
import '../styles/mobilemenu.css'


interface Props {
    handleClick: () => void;
}

const Mobilemenu = ({ handleClick }: Props) => {
    return (
        <div className='styledMenu' onClick={handleClick}>
            <div className="nav-mobile-signup-container">
                <Link to="/signup" >Signup</Link>
                <Link to="/login" >Login</Link>
            </div>
            <ul>
                <li><Link to="/courses"  >Courses</Link></li>
                <li><Link to="/plans" >Plans</Link></li>
                <li><Link to="/categories"  >Categories</Link></li>
                <li><Link to="/contact"  >Contact Us</Link></li>

            </ul>
        </div>
    )
}

export default Mobilemenu